import { defineMessages } from 'react-intl';

export default defineMessages({
  adminDescriptionOne: {
    id: 'frontbucket.editor.aiOptInModal.adminDescriptionOne',
    description:
      'Description for the first line of the AI opt in modal for admins',
    defaultMessage:
      'Get everyone up to speed quickly and consume information with ease, thanks to your virtual teammate.',
  },
  adminDescriptionTwo: {
    id: 'frontbucket.editor.aiOptInModal.adminDescriptionTwo',
    description:
      'Description for the second line of the AI opt in modal for admins',
    defaultMessage:
      'Turn on {atlassianIntelligenceLink} features for your users from Workspace settings.',
  },
  adminDescriptionTwoLink: {
    id: 'frontbucket.editor.aiOptInModal.adminDescriptionTwoLink',
    description:
      'Link to the Atlassian Intelligence page in Workspace settings',
    defaultMessage: 'Atlassian Intelligence',
  },
});
